<template>
  <div class="in-out-info mb-8">
    <div class="left-side">
      <div class="box">
        <vx-card>
          <div class="title">Current Occupancy</div>
          <div class="value text-green">{{ data.countTotal }}</div>
          <div class="flex justify-between">
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-person" />
              <span class="ml-2">{{ data.totalPerson }}</span>
            </div>
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-car" />
              <span class="ml-2">{{ data.totalCar }}</span>
            </div>
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-motorcycle" />
              <span class="ml-2">{{ data.totalMotorcycle }}</span>
            </div>
            <div>
              <font-awesome-icon icon="fa-solid fa-truck" />
              <span class="ml-2">{{ data.totalOtherVehicle }}</span>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="box">
        <vx-card>
          <div class="title">Entries</div>
          <div class="value text-blue"><font-awesome-icon icon="fa-solid fa-arrow-up" /> {{ data.countIn }}</div>
          <div class="flex justify-between">
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-person" />
              <span class="ml-2">{{ data.inPerson }}</span>
            </div>
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-car" />
              <span class="ml-2">{{ data.inCar }}</span>
            </div>
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-motorcycle" />
              <span class="ml-2">{{ data.inMotorcycle }}</span>
            </div>
            <div>
              <font-awesome-icon icon="fa-solid fa-truck" />
              <span class="ml-2">{{ data.inOtherVehicle }}</span>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="box">
        <vx-card>
          <div class="title">Exits</div>
          <div class="value text-red"><font-awesome-icon icon="fa-solid fa-arrow-down" /> {{ data.countOut }}</div>
          <div class="flex justify-between">
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-person" />
              <span class="ml-2">{{ data.outPerson }}</span>
            </div>
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-car" />
              <span class="ml-2">{{ data.outCar }}</span>
            </div>
            <div class="pr-3">
              <font-awesome-icon icon="fa-solid fa-motorcycle" />
              <span class="ml-2">{{ data.outMotorcycle }}</span>
            </div>
            <div>
              <font-awesome-icon icon="fa-solid fa-truck" />
              <span class="ml-2">{{ data.outOtherVehicle }}</span>
            </div>
          </div>
        </vx-card>
      </div>
      <!-- <vs-tooltip text="Show Counting Chart">
          <div class="box flex items-center justify-center toggle-chart" @click="toggleChart">
            <font-awesome-icon icon="fa-solid fa-chart-column" class="large-faicon" />
          </div>
        </vs-tooltip> -->
      <vs-tooltip text="Download Daily Report">
        <div class="box flex items-center justify-center toggle-chart" @click="showPopupSelectDateReport = true">
          <font-awesome-icon icon="fa-solid fa-file-lines" class="large-faicon" />
        </div>
      </vs-tooltip>
    </div>
    <div class="right-side" v-show="showPrint">
      <vs-tooltip text="Print Chart">

        <div class="box flex items-center justify-center toggle-chart" @click="printChart()">
          <feather-icon icon="PrinterIcon" class="m-0" svgClasses="icon" />
        </div>
      </vs-tooltip>
      <!-- <div class="box flex items-center justify-center toggle-chart" @click="$emit('csv')">
          <feather-icon
                icon="FileTextIcon"
                class="m-0"
                svgClasses="icon"
              />
          </div> -->
    </div>

    <vs-prompt title="Export CSV" @cancel="cancelExport" @accept="submitExportCsv" @close="cancelExport"
      :is-valid="validInputReport" :active.sync="showPopupSelectDateReport">
      <p>Download daily report (csv)</p>
      <div class="vx-row pt-4">
        <div class="vx-col sm:w-1/2 w-full mb-3">
          <datepicker placeholder="Start Date" :disabledDates="disabledDates" v-model="datestart"></datepicker>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-3">
          <datepicker placeholder="End Date" :disabledDates="disabledDates" v-model="dateend"></datepicker>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
export default {
  props: ['data'],
  data() {
    return {
      disabledDates: {
        from: new Date()
      },
      showPrint: false,
      showPopupSelectDateReport: false,
      datestart: null,
      dateend: null
    }
  },
  components: {
    Datepicker
  },
  computed: {
    validInputReport() {
      if (this.datestart != null && this.dateend != null) {
        return true
      }
      return false
    }
  },
  methods: {
    toggleChart() {
      this.showPrint = !this.showPrint
      this.$emit('togglechart')
    },
    printChart() {
      window.print();
    },
    submitExportCsv() {
      this.$emit('downloadDailyReport', { 'start': this.datestart, 'end': this.dateend })
    },
    cancelExport() {
      this.showPopupSelectDateReport = false
      this.datestart = null
      this.dateend = null
    }
  }
}
</script>

<style lang="scss" scoped>
.in-out-info {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .left-side {
    display: flex;
    flex-grow: 1;
  }

  .right-side {
    display: flex;
    justify-content: flex-end;
  }

  .box {
    // background-color: #FFFFFF;
    width: 25%;
    // border: 2px solid #1372ac;
    border-radius: 10px;
    padding: 10px;
    margin-right: 16px;

    &.toggle-chart {
      width: 54px;
      height: 54px;
      cursor: pointer;
    }

    .title {
      font-size: 12pt;
      font-weight: 600;
    }

    .value {
      font-weight: 700;
      font-size: 20pt;
    }

    .icon {
      width: 32px;
      height: 32px;
      color: #1372ac;
    }
  }

  .large-faicon {
    font-size: 32px;
    color: #1372ac;
  }
}
</style>